import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section style={{
      background: '#0A1220',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }}>
      {/* Background image with heavy overlay */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1168630fb-1771465106542.png",
        backgroundSize: 'cover',
        backgroundPosition: 'center 40%',
        filter: 'brightness(0.08) saturate(0.5)',
        pointerEvents: 'none'
      }} />
      {/* Diagonal color block */}
      <div style={{
        position: 'absolute', top: 0, left: 0,
        width: '40%', height: '100%',
        background: 'rgba(59,111,212,0.06)',
        clipPath: 'polygon(0 0, 85% 0, 100% 100%, 0 100%)',
        pointerEvents: 'none'
      }} />
      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1, textAlign: 'center' }}>
        {/* Celebration polaroids row */}
        <div style={{
          display: 'flex', justifyContent: 'center', gap: '24px',
          marginBottom: '64px', flexWrap: 'wrap'
        }}>
          {[
          {
            img: "https://images.unsplash.com/photo-1661004281300-bc6f55eb2215",
            alt: 'Winding Norwegian mountain road through autumn forest with golden foliage',
            label: 'Norske veier', rotate: '-4deg'
          },
          {
            img: "https://images.unsplash.com/photo-1708058849405-9383155ff3d7",
            alt: 'Dramatic Norwegian fjord with snow-capped mountains and crystal clear water',
            label: 'Fjordlandskap', rotate: '2deg'
          },
          {
            img: "https://images.unsplash.com/photo-1629302739375-9da07c8c5c04",
            alt: 'Northern lights aurora borealis over Norwegian winter landscape with mountains',
            label: 'Nordlys', rotate: '-2deg'
          }]?.
          map((card, i) =>
          <div key={i} style={{
            background: '#EEF0F2',
            padding: '10px 10px 36px',
            transform: `rotate(${card?.rotate})`,
            boxShadow: '0 12px 40px rgba(0,0,0,0.6)',
            width: '160px',
            flexShrink: 0
          }}>
              <img
              src={card?.img}
              alt={card?.alt}
              style={{
                width: '100%', height: '120px',
                objectFit: 'cover', display: 'block',
                filter: 'saturate(0.8)'
              }} />
            
              <div style={{
              marginTop: '10px', textAlign: 'center',
              fontFamily: 'Georgia, serif', fontStyle: 'italic',
              fontSize: '0.7rem', color: '#1a1a2e'
            }}>{card?.label}</div>
            </div>
          )}
        </div>

        {/* Heading */}
        <div style={{ marginBottom: '16px' }}>
          <div style={{
            fontFamily: 'Impact, Arial Black, sans-serif',
            fontSize: 'clamp(36px, 5.5vw, 72px)',
            fontWeight: 900, color: '#EEF0F2',
            lineHeight: 0.88, letterSpacing: '-0.03em',
            textTransform: 'uppercase',
            transform: 'rotate(-0.8deg)', display: 'inline-block'
          }}>KOM I GANG</div>
        </div>
        <div style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: 'clamp(28px, 4vw, 56px)',
          fontWeight: 700, color: '#3B6FD4',
          lineHeight: 0.95, letterSpacing: '-0.02em',
          marginBottom: '32px'
        }}>med NordPass.</div>

        <p style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '1.05rem', color: 'rgba(238,240,242,0.55)',
          lineHeight: 1.7, maxWidth: '480px',
          margin: '0 auto 48px'
        }}>
          Utforsk våre tjenester og ta kontroll over dine norske veireiser i dag.
        </p>

        {/* CTA Buttons */}
        <div style={{
          display: 'flex', gap: '16px',
          justifyContent: 'center', flexWrap: 'wrap'
        }}>
          <Link
            to="/tjenester-services"
            style={{
              display: 'inline-block',
              background: '#3B6FD4',
              border: 'none',
              padding: '18px 40px',
              fontFamily: 'Syne, sans-serif', fontSize: '0.85rem',
              fontWeight: 700, color: '#EEF0F2',
              letterSpacing: '0.12em', textTransform: 'uppercase',
              textDecoration: 'none',
              clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))',
              transition: 'background 0.2s',
              transform: 'rotate(-0.5deg)'
            }}
            onMouseEnter={(e) => {e.currentTarget.style.background = '#2d5ab8';}}
            onMouseLeave={(e) => {e.currentTarget.style.background = '#3B6FD4';}}>
            
            Utforsk Tjenester
          </Link>

          <Link
            to="/"
            style={{
              display: 'inline-block',
              background: 'transparent',
              border: '2px solid rgba(238,240,242,0.25)',
              padding: '16px 40px',
              fontFamily: 'Syne, sans-serif', fontSize: '0.85rem',
              fontWeight: 700, color: 'rgba(238,240,242,0.7)',
              letterSpacing: '0.12em', textTransform: 'uppercase',
              textDecoration: 'none',
              transition: 'all 0.2s',
              transform: 'rotate(0.5deg)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'rgba(238,240,242,0.6)';
              e.currentTarget.style.color = '#EEF0F2';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'rgba(238,240,242,0.25)';
              e.currentTarget.style.color = 'rgba(238,240,242,0.7)';
            }}>
            
            Tilbake til Hjem
          </Link>
        </div>
      </div>
    </section>);

};

export default CTASection;